import request from '@/plugins/axios'

/**
 * 登录
 * @param { Object } data 用户信息
 * @param { String } data.username 账号
 * @param { String } data.password 密码
 */
export function login (data) {
  return request.post('/system/auth/login', data)
}

// 刷新访问令牌
export function refreshToken (refreshToken) {
  return request.post(`/system/auth/refresh-token?refreshToken=${refreshToken}`)
}
